<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: BtnPrimary                                            |
| Section: atoms                                                   |
| Purpose: Primary call-to-action button or link with arrow icon. |
+------------------------------------------------------------------+
-->
<template>
    <a v-if="href" :href="href" @click="handleClick" class="BtnPrimary">
        <svg v-if="showIcon" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
            :fill="iconFillColor">
            <path
                d="M15.7063 9.20627C16.0969 8.81565 16.0969 8.18127 15.7063 7.79065L11.7063 3.79065C11.3156 3.40002 10.6812 3.40002 10.2906 3.79065C9.9 4.18127 9.9 4.81565 10.2906 5.20627L12.5844 7.50002H1C0.446875 7.50002 0 7.9469 0 8.50002C0 9.05315 0.446875 9.50002 1 9.50002H12.5844L10.2906 11.7938C9.9 12.1844 9.9 12.8188 10.2906 13.2094C10.6812 13.6 11.3156 13.6 11.7063 13.2094L15.7063 9.2094V9.20627Z"
                :fill="iconFillColor" />
        </svg>
        {{ label }}
    </a>
    <button v-else @click="handleClick" class="BtnPrimary">
        <svg v-if="showIcon" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
            :fill="iconFillColor">
            <path
                d="M15.7063 9.20627C16.0969 8.81565 16.0969 8.18127 15.7063 7.79065L11.7063 3.79065C11.3156 3.40002 10.6812 3.40002 10.2906 3.79065C9.9 4.18127 9.9 4.81565 10.2906 5.20627L12.5844 7.50002H1C0.446875 7.50002 0 7.9469 0 8.50002C0 9.05315 0.446875 9.50002 1 9.50002H12.5844L10.2906 11.7938C9.9 12.1844 9.9 12.8188 10.2906 13.2094C10.6812 13.6 11.3156 13.6 11.7063 13.2094L15.7063 9.2094V9.20627Z"
                :fill="iconFillColor" />
        </svg>
        {{ label }}
    </button>
</template>

<script>
export default {
    name: 'BtnPrimary',
    props: {
        label: {
            type: String,
            required: true
        },
        href: {
            type: String,
            default: null // Optional, so it can be null
        },
        linkClick: {
            type: Function,
            default: null // Optional click handler
        },
        showIcon: {
            type: Boolean,
            default: true // Show the icon by default
        },
        iconFillColor: {
            type: String,
            default: '#FFFFFF' // Default to white if no color is provided
        }
    },
    methods: {
        handleClick(event) {
            if (this.linkClick) {
                event.preventDefault(); // Prevent default anchor behavior
                this.linkClick(); // Call the function
            }
        }
    }
};
</script>